import { ChainId, NATIVE_CURRENCY, TokenAmount } from '@stichting-allianceblock-foundation/alliance-dex-sdk'
import React, { useState } from 'react'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
import { darken } from 'polished'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import { useActiveWeb3React } from '../../hooks'
import { useETHBalances, useTokenBalance } from '../../state/wallet/hooks'
import { CardNoise } from '../earn/styled'
import { TYPE } from '../../theme'

import { YellowCard } from '../Card'

import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'
import ClaimModal from '../claim/ClaimModal'
import { useToggleSelfClaimModal, useShowClaimPopup } from '../../state/application/hooks'
import { useUserHasAvailableClaim } from '../../state/claim/hooks'
import { useUserHasSubmittedClaim } from '../../state/transactions/hooks'
import { Dots } from '../swap/styleds'
import Modal from '../Modal'
import UniBalanceContent from './UniBalanceContent'
import { WALBT_ONLY } from './../../constants'

const HeaderFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  background: #fff;
  box-shadow: 0px 4px 27px rgba(70, 77, 137, 0.1);
  padding: 29px 71px;
  z-index: 2;
  
  position: fixed;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr;
    padding: 29px 71px;
    width: calc(100%);
    position: relative;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
  padding: 29px 71px;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    width: 100%;
    max-width: 960px;
    padding: 1rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 99;
    height: 72px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.bg1};
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  /* addresses safari's lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;
`

const HeaderRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
   width: 100%;
  `};
`

const HeaderLinks = styled(Row)`
  justify-content: center;
  @media (max-width: 425px) {
      display: block;
      
  };
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem 0 1rem 1rem;
    justify-content: flex-end;
  `};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)};
  border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;
  background: #3b4ffd;
  color: #fff;
  border: none;
  border-radius: 15px;

  :focus {
    border: 1px solid blue;
  }
`

const UNIAmount = styled(AccountElement)`
  color: white;
  padding: 4px 8px;
  height: 36px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.bg3};
  background: radial-gradient(174.47% 188.91% at 1.84% 0%, #5466fd 0%, #2172e5 100%), #edeef2;
`

const UNIWrapper = styled.span`
  width: fit-content;
  position: relative;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  :active {
    opacity: 0.9;
  }
`

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  white-space: nowrap;
  border-radius: 12px;
  padding: 8px 12px;
  border: none;
  background-color: #ededf7;
  color: #3b4ffd;
  font-weight: 400;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    opacity: 0.75;
  }
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({
  activeClassName
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }

  @media (max-width: 425px){
    margin-top:5px;
  };
`

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.MATIC_MUMBAI]: 'Mumbai',
  [ChainId.EWC_VOLTA]: 'EWC Volta'
}

export default function Header() {
  const { account, chainId } = useActiveWeb3React()
  const { t } = useTranslation()
  const WALBT  = chainId ? WALBT_ONLY[chainId][0] : undefined
  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const walbtBalance: TokenAmount | undefined = useTokenBalance(account ?? undefined, WALBT)
  const toggleClaimModal = useToggleSelfClaimModal()

  const availableClaim: boolean = useUserHasAvailableClaim(account)

  const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)

  const [showUniBalanceModal, setShowUniBalanceModal] = useState(false)
  const showClaimPopup = useShowClaimPopup()


  return (
    <HeaderFrame>
      <ClaimModal />
      <Modal isOpen={showUniBalanceModal} onDismiss={() => setShowUniBalanceModal(false)}>
        <UniBalanceContent setShowUniBalanceModal={setShowUniBalanceModal} />
      </Modal>
      <HeaderRow>
        <Title href=".">
          <UniIcon>
            <div className="svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="131" height="38" viewBox="0 0 131 38" fill="none">
            <path d="M48.494 20.4H54.218C55.586 20.4 56.792 20.664 57.836 21.192C58.892 21.708 59.708 22.44 60.284 23.388C60.872 24.336 61.166 25.44 61.166 26.7C61.166 27.96 60.872 29.064 60.284 30.012C59.708 30.96 58.892 31.698 57.836 32.226C56.792 32.742 55.586 33 54.218 33H48.494V20.4ZM54.074 30.606C55.334 30.606 56.336 30.258 57.08 29.562C57.836 28.854 58.214 27.9 58.214 26.7C58.214 25.5 57.836 24.552 57.08 23.856C56.336 23.148 55.334 22.794 54.074 22.794H51.41V30.606H54.074ZM73.1211 30.66V33H63.3651V20.4H72.8871V22.74H66.2631V25.476H72.1131V27.744H66.2631V30.66H73.1211ZM83.2562 33L80.2142 28.626L77.2262 33H73.8782L78.5402 26.592L74.1122 20.4H77.4242L80.3222 24.486L83.1662 20.4H86.3162L81.9242 26.484L86.6222 33H83.2562Z" fill="#363C72"/>
            <path d="M53.6514 10.4023H49.4814L48.5449 13H47.1914L50.9922 3.04688H52.1406L55.9482 13H54.6016L53.6514 10.4023ZM49.8779 9.32227H53.2617L51.5664 4.66699L49.8779 9.32227ZM58.4639 13H57.1992V2.5H58.4639V13ZM61.8682 13H60.6035V2.5H61.8682V13ZM65.2725 13H64.0078V5.60352H65.2725V13ZM63.9053 3.6416C63.9053 3.43652 63.9668 3.26335 64.0898 3.12207C64.2174 2.98079 64.4043 2.91016 64.6504 2.91016C64.8965 2.91016 65.0833 2.98079 65.2109 3.12207C65.3385 3.26335 65.4023 3.43652 65.4023 3.6416C65.4023 3.84668 65.3385 4.01758 65.2109 4.1543C65.0833 4.29102 64.8965 4.35938 64.6504 4.35938C64.4043 4.35938 64.2174 4.29102 64.0898 4.1543C63.9668 4.01758 63.9053 3.84668 63.9053 3.6416ZM71.8691 13C71.7962 12.8542 71.737 12.5944 71.6914 12.2207C71.1035 12.8314 70.4017 13.1367 69.5859 13.1367C68.8568 13.1367 68.2575 12.9316 67.7881 12.5215C67.3232 12.1068 67.0908 11.5827 67.0908 10.9492C67.0908 10.179 67.3825 9.58203 67.9658 9.1582C68.5537 8.72982 69.3786 8.51562 70.4404 8.51562H71.6709V7.93457C71.6709 7.49251 71.5387 7.1416 71.2744 6.88184C71.0101 6.61751 70.6204 6.48535 70.1055 6.48535C69.6543 6.48535 69.276 6.59928 68.9707 6.82715C68.6654 7.05501 68.5127 7.33073 68.5127 7.6543H67.2412C67.2412 7.28516 67.3711 6.92969 67.6309 6.58789C67.8952 6.24154 68.2507 5.9681 68.6973 5.76758C69.1484 5.56706 69.6429 5.4668 70.1807 5.4668C71.0329 5.4668 71.7005 5.68099 72.1836 6.10938C72.6667 6.5332 72.9173 7.11882 72.9355 7.86621V11.2705C72.9355 11.9495 73.0221 12.4896 73.1953 12.8906V13H71.8691ZM69.7705 12.0361C70.167 12.0361 70.543 11.9336 70.8984 11.7285C71.2539 11.5234 71.5114 11.2568 71.6709 10.9287V9.41113H70.6797C69.1302 9.41113 68.3555 9.86458 68.3555 10.7715C68.3555 11.168 68.4876 11.4779 68.752 11.7012C69.0163 11.9245 69.3558 12.0361 69.7705 12.0361ZM76.1143 5.60352L76.1553 6.5332C76.7204 5.82227 77.4587 5.4668 78.3701 5.4668C79.9333 5.4668 80.7217 6.34863 80.7354 8.1123V13H79.4707V8.10547C79.4661 7.57227 79.3431 7.17806 79.1016 6.92285C78.8646 6.66764 78.4932 6.54004 77.9873 6.54004C77.5771 6.54004 77.2171 6.64941 76.9072 6.86816C76.5973 7.08691 76.3558 7.37402 76.1826 7.72949V13H74.918V5.60352H76.1143ZM85.6094 12.1045C86.0605 12.1045 86.4548 11.9678 86.792 11.6943C87.1292 11.4209 87.3161 11.0791 87.3525 10.6689H88.5488C88.526 11.0928 88.3802 11.4961 88.1113 11.8789C87.8424 12.2617 87.4824 12.5671 87.0312 12.7949C86.5846 13.0228 86.1107 13.1367 85.6094 13.1367C84.6022 13.1367 83.8001 12.8018 83.2031 12.1318C82.6107 11.4574 82.3145 10.5368 82.3145 9.37012V9.1582C82.3145 8.43815 82.4466 7.79785 82.7109 7.2373C82.9753 6.67676 83.3535 6.24154 83.8457 5.93164C84.3424 5.62174 84.9281 5.4668 85.6025 5.4668C86.432 5.4668 87.1201 5.71517 87.667 6.21191C88.2184 6.70866 88.5124 7.35352 88.5488 8.14648H87.3525C87.3161 7.66797 87.1338 7.27604 86.8057 6.9707C86.4821 6.66081 86.0811 6.50586 85.6025 6.50586C84.96 6.50586 84.4609 6.73828 84.1055 7.20312C83.7546 7.66341 83.5791 8.33105 83.5791 9.20605V9.44531C83.5791 10.2975 83.7546 10.9538 84.1055 11.4141C84.4564 11.8743 84.9577 12.1045 85.6094 12.1045ZM93.04 13.1367C92.0374 13.1367 91.2217 12.8086 90.5928 12.1523C89.9639 11.4915 89.6494 10.6097 89.6494 9.50684V9.27441C89.6494 8.54069 89.7884 7.88672 90.0664 7.3125C90.349 6.73372 90.7409 6.28255 91.2422 5.95898C91.748 5.63086 92.2949 5.4668 92.8828 5.4668C93.8444 5.4668 94.5918 5.78353 95.125 6.41699C95.6582 7.05046 95.9248 7.95736 95.9248 9.1377V9.66406H90.9141C90.9323 10.3932 91.1442 10.9834 91.5498 11.4346C91.96 11.8812 92.4795 12.1045 93.1084 12.1045C93.555 12.1045 93.9333 12.0133 94.2432 11.8311C94.5531 11.6488 94.8242 11.4072 95.0566 11.1064L95.8291 11.708C95.2093 12.6605 94.2796 13.1367 93.04 13.1367ZM92.8828 6.50586C92.3724 6.50586 91.944 6.69271 91.5977 7.06641C91.2513 7.43555 91.0371 7.95508 90.9551 8.625H94.6602V8.5293C94.6237 7.88672 94.4505 7.38997 94.1406 7.03906C93.8307 6.68359 93.4115 6.50586 92.8828 6.50586ZM97.5928 13V3.04688H100.847C101.927 3.04688 102.738 3.27018 103.28 3.7168C103.827 4.16341 104.101 4.82422 104.101 5.69922C104.101 6.16406 103.968 6.5765 103.704 6.93652C103.44 7.29199 103.08 7.56771 102.624 7.76367C103.162 7.91406 103.586 8.20117 103.896 8.625C104.21 9.04427 104.367 9.54557 104.367 10.1289C104.367 11.0221 104.078 11.724 103.499 12.2344C102.92 12.7448 102.102 13 101.045 13H97.5928ZM98.9053 8.34473V11.9268H101.072C101.683 11.9268 102.164 11.7695 102.515 11.4551C102.87 11.1361 103.048 10.6986 103.048 10.1426C103.048 8.94401 102.396 8.34473 101.093 8.34473H98.9053ZM98.9053 7.29199H100.888C101.462 7.29199 101.92 7.14844 102.262 6.86133C102.608 6.57422 102.781 6.18457 102.781 5.69238C102.781 5.14551 102.622 4.74902 102.303 4.50293C101.984 4.25228 101.498 4.12695 100.847 4.12695H98.9053V7.29199ZM107.491 13H106.227V2.5H107.491V13ZM109.187 9.2334C109.187 8.50879 109.328 7.8571 109.61 7.27832C109.897 6.69954 110.294 6.25293 110.8 5.93848C111.31 5.62402 111.891 5.4668 112.543 5.4668C113.55 5.4668 114.364 5.81543 114.983 6.5127C115.608 7.20996 115.92 8.13737 115.92 9.29492V9.38379C115.92 10.1038 115.781 10.751 115.503 11.3252C115.229 11.8949 114.835 12.3392 114.32 12.6582C113.81 12.9772 113.222 13.1367 112.557 13.1367C111.554 13.1367 110.741 12.7881 110.116 12.0908C109.496 11.3936 109.187 10.4707 109.187 9.32227V9.2334ZM110.458 9.38379C110.458 10.2041 110.647 10.8626 111.025 11.3594C111.408 11.8561 111.919 12.1045 112.557 12.1045C113.199 12.1045 113.71 11.8538 114.088 11.3525C114.466 10.8467 114.655 10.1403 114.655 9.2334C114.655 8.4222 114.462 7.76595 114.074 7.26465C113.691 6.75879 113.181 6.50586 112.543 6.50586C111.919 6.50586 111.415 6.75423 111.032 7.25098C110.649 7.74772 110.458 8.45866 110.458 9.38379ZM120.473 12.1045C120.924 12.1045 121.318 11.9678 121.655 11.6943C121.993 11.4209 122.179 11.0791 122.216 10.6689H123.412C123.389 11.0928 123.243 11.4961 122.975 11.8789C122.706 12.2617 122.346 12.5671 121.895 12.7949C121.448 13.0228 120.974 13.1367 120.473 13.1367C119.465 13.1367 118.663 12.8018 118.066 12.1318C117.474 11.4574 117.178 10.5368 117.178 9.37012V9.1582C117.178 8.43815 117.31 7.79785 117.574 7.2373C117.839 6.67676 118.217 6.24154 118.709 5.93164C119.206 5.62174 119.791 5.4668 120.466 5.4668C121.295 5.4668 121.983 5.71517 122.53 6.21191C123.082 6.70866 123.376 7.35352 123.412 8.14648H122.216C122.179 7.66797 121.997 7.27604 121.669 6.9707C121.345 6.66081 120.944 6.50586 120.466 6.50586C119.823 6.50586 119.324 6.73828 118.969 7.20312C118.618 7.66341 118.442 8.33105 118.442 9.20605V9.44531C118.442 10.2975 118.618 10.9538 118.969 11.4141C119.32 11.8743 119.821 12.1045 120.473 12.1045ZM126.898 9.5752L126.105 10.4023V13H124.841V2.5H126.105V8.85059L126.782 8.03711L129.086 5.60352H130.624L127.746 8.69336L130.959 13H129.476L126.898 9.5752Z" fill="#4F5477" fillOpacity="0.75"/>
            <g clipPath="url(#clip0)">
            <path fillRule="evenodd" clipPath="evenodd" d="M1.64805 26.2661L7.06365 23.2764C7.42432 23.6607 8.00611 23.8112 8.50564 23.6857L14.8151 33.868L1.64805 26.2661V26.2661ZM30.2013 26.2661L17.408 33.6523L23.3981 23.6371C23.8541 23.7566 24.3615 23.6725 24.7011 23.3483C24.7275 23.3232 24.7524 23.2974 24.7759 23.2711L30.2013 26.2661ZM16.7222 18.8251L22.4226 21.972C22.3539 22.1925 22.3392 22.4287 22.3922 22.6577C22.4477 22.8976 22.5672 23.0994 22.7265 23.2592L16.7222 33.2978V18.8251ZM15.1271 18.8251V32.9089L9.16082 23.2804C9.47594 22.9067 9.51481 22.4261 9.37217 22.002L15.1271 18.8251V18.8251ZM1.08398 10.1922L6.75684 13.3238C6.7111 13.527 6.71092 13.7395 6.76625 13.944C6.84489 14.2345 7.01411 14.4645 7.23106 14.6292L1.08398 25.3623V10.1922V10.1922ZM30.7653 10.1924V25.3464L24.7293 14.5214C25.0592 14.1875 25.1427 13.7505 25.0572 13.3434L30.7653 10.1924V10.1924ZM25.0834 22.5608L29.7737 25.1499L24.1291 15.0269V21.0252C24.7269 21.2383 25.1424 21.9181 25.0834 22.5608ZM7.72028 21.053V15.325L2.10166 25.1356L6.7337 22.5785C6.65126 21.9324 7.08173 21.2551 7.72028 21.053ZM15.1271 17.9445V17.9452L8.95743 21.351C8.82202 21.2233 8.66401 21.1226 8.49081 21.061V14.8902C8.70017 14.8398 8.8956 14.7414 9.05488 14.5925L15.1271 17.9445ZM16.7222 17.9445L22.838 14.5684C22.991 14.6915 23.1698 14.781 23.3587 14.8345V21.0165C23.1618 21.0781 22.9848 21.1841 22.8364 21.3204L16.7222 17.9452V17.9445ZM16.7222 2.37641L22.7483 12.6133C22.4289 12.965 22.279 13.4668 22.4092 13.9248L22.4094 13.9252L16.7222 17.0646V2.37641V2.37641ZM15.1271 2.39214V17.0646L9.42839 13.9186C9.50161 13.5327 9.39296 13.1214 9.16805 12.7972L15.1271 2.39214V2.39214ZM17.3995 2.00795L30.4 9.51385L24.7199 12.6495C24.48 12.3617 24.1415 12.1653 23.7615 12.1579C23.7378 12.1577 23.7141 12.1581 23.6905 12.1588C23.5907 12.1633 23.4941 12.1791 23.4017 12.2047L17.3995 2.00795V2.00795ZM14.4638 2L8.56927 12.2926C8.43043 12.232 8.28037 12.1968 8.12326 12.1937C8.09958 12.1937 8.0759 12.1939 8.05221 12.1948C7.68051 12.2107 7.35327 12.3855 7.11662 12.6424L1.44936 9.51385L14.4638 2V2Z" fill="#5466FD"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="32" height="32" fill="white" transform="translate(0 2)"/>
            </clipPath>
            </defs>
            </svg>
            </div>
          </UniIcon>
        </Title>
        <HeaderLinks>
          <StyledNavLink id={`swap-nav-link`} to={'/swap'}>
            {t('swap')}
          </StyledNavLink>
          <StyledNavLink id={`pool-nav-link`} to={'/pool'}>
            {t('pool')}
          </StyledNavLink>
        </HeaderLinks>
      </HeaderRow>
      <HeaderControls>
        <HeaderElement>
          <HideSmall>
            {chainId && NETWORK_LABELS[chainId] && (
              <NetworkCard title={NETWORK_LABELS[chainId]}>{NETWORK_LABELS[chainId]} </NetworkCard>
            )}
          </HideSmall>
          {availableClaim && !showClaimPopup && (
            <UNIWrapper onClick={toggleClaimModal}>
              <UNIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }}>
                <TYPE.white padding="0 2px">
                  {claimTxn && !claimTxn?.receipt ? <Dots>Claiming ALBT</Dots> : 'Claim ALBT'}
                </TYPE.white>
              </UNIAmount>
              <CardNoise />
            </UNIWrapper>
          )}
          <AccountElement active={!!account} style={{ pointerEvents: 'none' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                  <span>
                    {userEthBalance?.toSignificant(4)} {NATIVE_CURRENCY[chainId as ChainId].symbol}
                  </span>
                  <span style={{ marginLeft: '0.75rem' }}>
                    {walbtBalance?.toSignificant(4)} {WALBT?.symbol}
                  </span>
              </BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
        <HeaderElementWrap>
          {/* <Menu /> */}
        </HeaderElementWrap>
      </HeaderControls>
    </HeaderFrame>
  )
}
